<template>
  <div class="num_all">

    <el-row >
      <el-col :span="18" :justify="end" ><div class="grid-content num_r">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item  v-for="item in itemData.numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
        </el-menu>
                </div></el-col>
              </el-row>
            </div>
          </template>
<style>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}

</style>
          <script>
          import {Data} from "../js/image/mun2";

          export default {
            name: "mun2",
            data() {
              return {
                dataAll: Data,
                itemData: {},
              }
            },
            mounted() {
              let that = this;

              for(let index in that.dataAll){
                let itemData= that.dataAll[index];
                if(that.$parent.$parent.message == itemData.type){
                  that.itemData = itemData;
                  break;
                }
              }
            },
          }
          </script>

          <style scoped>

          </style>



// WEBPACK FOOTER //
// src/components/image/mun2.vue